import type { FaireProductEntity } from "../../entity_types/product";

export const p_m5fmbdt3ek: FaireProductEntity = {
  token: "p_m5fmbdt3ek",
  type: "product",
  name: "Mini Ceramic Frog Candles (10-Pack)",
  brandToken: "b_brgwq19hx1",
  brandName: "Earths Elements Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/a7b1a70cc1107786478d83469c9ca794efdeafee70a6bd7555155b4426ee2823.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e4f53592eb0447c784f1732faa0b737ea88bdfb7cae809cb13d6f7b9b565ca55.jpeg",
    "https://cdn.faire.com/fastly/0a02bc4f133e3ecf26e40acb636c9ab9502adbb17b00c158c9272c7f10f4e5f9.jpeg",
    "https://cdn.faire.com/fastly/ea4713fab7d131f63f7949673b0e323d701ff341e72fe43cbb2e8efafe374cb9.jpeg",
  ],
  priceDollars: 4.16,
  description:
    'CNDL-MFT\nMini Ceramic Frog Candles (10-Pack)\nThis set includes 10 mini frogs, displayed on two wooden trays, (5 frogs per tray). Each tray features assorted fragrances and colors. The trays are individually wrapped with a colorful flower\n1.25"L x 0.75"W\nMade in Thailand\nMin. 6',
  tags: [],
  msrpDollars: 8.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:59.663Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
